import React from 'react';
import useLocale from '../../../../hooks/useLocale';
import { Form } from 'react-bootstrap';
import { CalenderInput } from '../../../../components/base/CalenderInput';
import moment from 'moment';
import { ICompanyClientContext } from '../types';
import PagesHeader from '../../../../components/base/PagesHeader';
import MonthAndYearDropdown from '../../../../section/MonthAndYearDropdown';
import { MonthSelectOption } from '../../../../types';
import { Calendar } from '../../../../util/calendar';

interface DeploymentProps {
  deployment: {
    systemDeploymentMonth: string | null;
    employeeInvitationSendOuts: string | null;
  };
  updateDeployment: ICompanyClientContext['updateDeployment'];
  isEditMode?: boolean;
  disabled?: boolean;
  context: ICompanyClientContext;
}

const Deployment: React.FC<DeploymentProps> = ({ deployment, updateDeployment, isEditMode, disabled, context }) => {
  const now = moment();
  let minInvitationDate = now.toDate();
  let maxInvitationDate: Date | undefined = undefined;

  const upcomingSystemDeploymentMonthList: MonthSelectOption[] = Calendar.getMonthlyOptionAdapter({
    noOfMonths: 5,
    startFrom: Calendar.currentMonthStartDate,
    emptyMonths: true,
  });

  const onSystemDeploymentMonthChange = (month: string | null) => {
    updateDeployment('systemDeploymentMonth', month);
    updateDeployment('employeeInvitationSendOuts', null);
  };

  const onEmployeeInvitationSendOutsChange = (date: string | null) => {
    updateDeployment('employeeInvitationSendOuts', date);
  };

  if (deployment.systemDeploymentMonth) {
    maxInvitationDate = moment(deployment.systemDeploymentMonth, 'YYYY-MM-DD').endOf('month').toDate();
  }

  const { localize } = useLocale();
  return (
    <div>
      <PagesHeader pageTitle={localize('COMPANY.deployment')} headingClass="fs-h3 font-black" translate={false} />
      <div className="form-section mb-3 dark-content-section">
        <div className="cr-form-row">
          <div>
            <Form.Label className="fs-name mb-0">
              {localize('COMPANY.system_deployment_month')}
              <span className="font-weight-400 d-block theme-text">
                {localize('COMPANY.system_deployment_month_sub')}
              </span>
            </Form.Label>
            <MonthAndYearDropdown
              value={deployment.systemDeploymentMonth || ''}
              onOptionSelect={onSystemDeploymentMonthChange}
              customOptions={upcomingSystemDeploymentMonthList}
            />
          </div>
          <div>
            <Form.Label className="fs-name mb-0">
              {localize('COMPANY.employee_invitation_send_outs')}
              <span className="font-weight-400 d-block theme-text">
                {localize('COMPANY.employee_invitation_send_outs_sub')}
              </span>
            </Form.Label>
            <div className="date-input">
              <CalenderInput
                onChangeHandler={onEmployeeInvitationSendOutsChange}
                showMonthYearPicker={false}
                minDate={minInvitationDate}
                maxDate={maxInvitationDate}
                datepicker
                value={deployment.employeeInvitationSendOuts}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deployment;
